document.addEventListener("DOMContentLoaded", () => {
  const els = document.querySelectorAll("[data-reveal]");
  if (!els.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) e.target.classList.add("is-visible");
      });
    },
    { threshold: 0.2 }
  );

  els.forEach((el) => io.observe(el));
});
